<div class="card p-4">
  <div class="row">
    <div class="col-12">
      <h5>
        {{ 'Options TLS' | translate }}
        <div class="btn-container">
          <button class="btn btn-primary btn-sm btn-danger" (click)="cancel()">
            {{ 'Annuler' | translate }}
          </button>
          <button class="btn btn-primary btn-sm" (click)="save()" [disabled]="tlsFormGroup.invalid">
            {{ 'valider' | translate }}
          </button>
        </div>
      </h5>
      <hr style="margin-bottom: 0.8rem" />
    </div>
  </div>
  @if (tlsFormGroup) {
    <div class="row" [formGroup]="tlsFormGroup">
      <div class="col-xxl-6">
        <div class="form-group row">
          <div class="col-md-6">
            <app-label label="Nom" for="tls-options-name" />
          </div>
          <div class="col-md-6">
            <input type="text" id="tls-options-name" class="form-control" formControlName="name" />
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-6">
            <app-label label="ClientAuthType.label" for="tls-options-clientAuthType" />
          </div>
          <div class="col-md-6">
            <select type="text" id="tls-options-clientAuthType" class="form-control" formControlName="clientAuthType">
              @for (clientAuthType of clientAuthTypesTable; track $index) {
                <option [value]="clientAuthType">
                  {{ 'ClientAuthType.' + clientAuthType | translate }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="col-xxl-6">
        <div class="form-group row">
          <div class="col-md-6">
            <app-label label="TlsOptions.minTlsVersion" for="minTlsVersion" />
          </div>
          <div class="col-md-6">
            <select type="text" id="minTlsVersion" class="form-control" formControlName="minTlsVersion">
              @for (version of TlsVersions.filter(allowedMinVersion); track version) {
                <option [value]="version">{{ 'TlsVersion.' + version | translate }}</option>
              }
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-6">
            <app-label label="TlsOptions.maxTlsVersion" for="maxTlsVersion" />
          </div>
          <div class="col-md-6">
            <select type="text" id="maxTlsVersion" class="form-control" formControlName="maxTlsVersion">
              @for (version of TlsVersions.filter(allowedMaxVersion); track version) {
                <option [value]="version">{{ 'TlsVersion.' + version | translate }}</option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>

    @if (tlsFormGroup.get('clientAuthType').value !== 'IgnoreCert') {
      <div class="row">
        <div class="col-12">
          <app-label label="mTLS.CaCerts" />
        </div>
        <div class="col">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>{{ 'Certificate.subject' | translate }}</th>
                <th>{{ 'Fin de validité' | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (tlsFormGroup.get('clientAuthCaCerts').value.length == 0) {
                <tr>
                  <td colspan="3" class="no-data">
                    {{ 'TlsOptions.noCaCert' | translate }}
                  </td>
                </tr>
              }
              @for (
                cert of tlsFormGroup.get('clientAuthCaCerts').value.map(extractCertInfo);
                track cert.serialNumber;
                let index = $index
              ) {
                <tr>
                  <td>{{ cert.subject }}</td>
                  <td>{{ cert.notAfter | dateFormat }}</td>
                  <td>
                    <div class="actions"><i class="icofont icofont-ui-delete" (click)="deleteCaCert(index)"></i></div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-xxl-6">
          <textarea
            name="add-cert"
            class="form-control"
            [formControl]="certFormControl"
            [placeholder]="'TlsOptions.caCertPlaceholder' | translate"
          ></textarea>
        </div>
        <div class="validation-certificate">
          @if (certInfo) {
            <div class="validity">
              <div class="input-validity form-group">
                <label>{{ 'Fin de validité' | translateLabel }}</label>
                <div class="col no-margin">
                  <span class="bold-value">{{ certInfo.notAfter | dateFormat }}</span>
                </div>
              </div>
              <div class="input-validity form-group">
                <label>{{ 'Certificate.subject' | translateLabel }}</label>
                <div class="col no-margin">
                  <span class="bold-value">{{ certInfo.subject }}</span>
                </div>
              </div>
            </div>
          }
          @if (certificateError) {
            <div class="error">{{ certificateError }}</div>
          }
          <div class="cert-actions">
            <button (click)="addCertificate()" [disabled]="!certInfo || !!certificateError" class="btn btn-primary">
              {{ 'TlsOptions.addCaCert' | translate }}
            </button>
          </div>
        </div>
      </div>
    }
  }
</div>
